export default {
    SET_CATEGORY: "setCategory",
    SET_PRODUCTS: "setDevices",
    SET_PAGE: "setPage",
    PRODUCT_SUMMARY: "setProductSummary",
    SET_LOADING: "setLoading",
    SET_ERROR: "setError",
    UPDATE_PAGE_NUMBER: "updatePageNumber",
    SET_FILTERED_PRODUCTS: "setFilteredProducts",
};
